import script from "./project.vue?vue&type=script&setup=true&lang=js"
export * from "./project.vue?vue&type=script&setup=true&lang=js"

import "./project.vue?vue&type=style&index=0&id=1dfde596&lang=css"

const __exports__ = script;

export default __exports__